<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Announcement List</h4>
          <div class="md-card-header-icon md-card-header-green text-right">
            <md-button
              v-if="$store.role === 1 || $store.role === 4"
              @click="goToCreate"
              class="md-success"
              >CREATE ANNOUNCEMENT</md-button
            >
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="pagination.perPage"
                  name="pages"
                  @md-selected="customSort"
                >
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div>
                <md-button
                  style="margin-left: 10px"
                  @click="filterPanel"
                  class="md-info"
                >
                  Filters
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="clearFilters"
                  class="md-primary md-just-icon md-round"
                >
                  <md-icon>delete_sweep</md-icon>
                  <md-tooltip md-direction="bottom">Clear Filters</md-tooltip>
                </md-button>
              </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="University" md-sort-by="university" v-if="item.university">{{
                item.university.name
              }}</md-table-cell>
              <md-table-cell md-label="University" md-sort-by="university" v-else>General</md-table-cell>
              <md-table-cell md-label="Title" md-sort-by="title">{{
                item.title
              }}</md-table-cell>
              <md-table-cell md-label="Created Date">{{
                item.created_date
              }}</md-table-cell>
              <md-table-cell md-label="Modified Date">{{
                item.modified_date
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  style="margin-right: 14px;"
                  class="md-just-icon md-warning md-round"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>create</md-icon>
                  <md-tooltip md-direction="bottom">Edit</md-tooltip>
                </md-button>
                <md-button
                  style="margin-right: 10px;"
                  class="md-just-icon md-danger md-round mg-10"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                  <md-tooltip md-direction="bottom">Delete</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @page="updatePage"
          >
          </pagination>
        </md-card-actions>
      </md-card>
      <md-dialog :md-active.sync="showFilters" class="filterPanelClass">
        <md-dialog-title>Filters</md-dialog-title>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>University</label>
            <md-select v-model="university" name="university">
              <md-option value="">Select University</md-option>
              <md-option
                v-for="c in universities"
                v-bind:key="c.id"
                :value="c.id"
                >{{ c.name }}</md-option
              >
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-datepicker v-model="created_date" md-immediately>
            <label>Created Date</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-datepicker v-model="modified_date" md-immediately>
            <label>Modified Date</label>
          </md-datepicker>
        </div>

        <md-dialog-actions>
          <md-button class="md-danger" @click="showFilters = false"
            >Close</md-button
          >
          <md-button class="md-success" @click="addFilter">Filter</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    getParams() {
      return {
        ordering: this.getSortingKey(),
        limit: this.pagination.perPage,
        offset: this.from,
        ...this.searchQuery
      };
    }
  },
  data() {
    return {
      currentSort: "id",
      currentSortOrder: "desc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30],
        total: 0
      },
      footerTable: [
        "University",
        "Title",
        "Created Date",
        "Modified Date",
        "Actions"
      ],
      searchQuery: {},
      propsToSearch: [
        "id",
        "title",
        "university",
        "created_date",
        "modified_date"
      ],
      tableData: [],
      searchedData: [],
      first: true,

      table_spinner: true,
      showFilters: false,

      universities: null,

      university: null,
      title: null,
      created_date: null,
      modified_date: null
    };
  },
  methods: {
    getPrograms() {
      if (this.university && this.type) {
        this.$store
          .getPrograms(
            { university: this.university, type: this.type, ordering: "name" },
            true
          )
          .then(response => {
            this.programs = response.data.results;
          })
          .catch(error => {
            this.$notify({
              message: error.message,
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top"
            });
          });
      }
    },
    goToCreate: function() {
      this.$router.push({ name: "Announcement Create" });
    },
    filterPanel: function() {
      this.showFilters = true;
      if (this.universities) {
        return;
      }
      this.$store
        .getUniversities({}, true)
        .then(response => {
          this.universities = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    clearFilters: function() {
      this.searchQuery = {};
      this.university = null;
      this.title = null;
      this.created_date = null;
      this.modified_date = null;
      this.pagination.currentPage = 1;
      this.getAnnouncements();
    },
    addFilter: function() {
      let origin_params = {};
      let params = {
        university: this.university,
        title: this.title,
        created_date: this.created_date,
        modified_date: this.modified_date
      };
      for (const field in params) {
        if (
          params[field] === null ||
          params[field] === undefined ||
          params[field] === ""
        ) {
          continue;
        }
        origin_params[field] = params[field];
      }
      this.searchQuery = origin_params;
      this.pagination.currentPage = 1;
      this.getAnnouncements();
      this.showFilters = false;
    },
    customSort(value) {
      if (this.first) {
        this.first = false;
        this.checkQueryParam();
      } else {
        this.pagination.currentPage = 1;
      }
      this.getAnnouncements();
    },
    getSortingKey() {
      var key = this.currentSort;
      if (this.currentSortOrder === "desc") {
        key = "-" + this.currentSort;
      }
      return key;
    },
    handleEdit(item) {
      this.$router.push({
        name: "Announcement Update",
        params: { id: item.id }
      });
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .deleteUniversityAnnouncement(item.id)
            .then(response => {
              this.deleteRow(item);
              this.$notify({
                message: "Deleted!",
                icon: "add_alert",
                type: "warning",
                verticalAlign: "top"
              });
            })
            .catch(error => {
              this.$notify({
                message: JSON.stringify(error.response.data),
                icon: "add_alert",
                type: "warning",
                verticalAlign: "top"
              });
            });
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    getAnnouncements() {
      this.tableData = [];
      this.table_spinner = true;
      var params = this.getParams;
      this.$store
        .getUniversityAnnouncements(params)
        .then(response => {
          this.tableData = response.data.results;
          this.pagination.total = response.data.count;
          if (params.offset) {
            this.pagination.currentPage = this.getCurrentPage(params.offset);
          }
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: JSON.stringify(error.response.data),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    updatePage(page) {
      this.getAnnouncements();
    },
    getCurrentPage(offset) {
      return offset / this.pagination.perPage + 1;
    },
    checkQueryParam() {
      if (window.location.search !== "") {
        var params = window.location.search
          .slice(1)
          .split("&")
          .map(p => p.split("="))
          .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (params.ordering) {
          if (params.ordering[0] === "-") {
            this.currentSortOrder = "desc";
            params.ordering = params.ordering.replace("-", "");
          } else {
            this.currentSortOrder = "asc";
          }
          this.currentSort = params.ordering;
          delete params.ordering;
        }
        if (params.limit) {
          this.pagination.perPage = parseInt(params.limit);
          delete params.limit;
        }
        if (params.offset) {
          this.pagination.currentPage = this.getCurrentPage(params.offset);
          delete params.offset;
        }
        this.searchQuery = params;
      }
    }
  },
  watch: {
    searchQuery(query) {
      let params = this.getParams;
      let query_param = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      window.history.replaceState(
        "page",
        "Title",
        window.location.pathname + "?" + query_param
      );
    },
    pagination: {
      deep: true,
      handler(val) {
        let params = this.getParams;
        let query_param = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
        window.history.replaceState(
          "page",
          "Title",
          window.location.pathname + "?" + query_param
        );
      }
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
